import React, { useCallback, useEffect } from 'react';
import { batch, useDispatch } from 'react-redux';
import { Icon } from '@vectord/components';

import {
  COURSE_PAUSE_REQUESTED_REQUEST_MODAL_STAGES,
  setSelectedRequest,
  setCoursePauseRequestedRequestUpdateModalStage,
} from 'features/courseResume';
import styles from './CoursePauseRequestedRequestUpdateModalStages.module.scss';

function SuccessStage() {
  const dispatch = useDispatch();

  const handleModalClose = useCallback(() => {
    batch(() => {
      dispatch(setSelectedRequest(null));
      dispatch(
        setCoursePauseRequestedRequestUpdateModalStage(
          COURSE_PAUSE_REQUESTED_REQUEST_MODAL_STAGES.notOpen
        )
      );
    });
  }, [dispatch]);

  useEffect(() => {
    const timer = setTimeout(() => {
      handleModalClose();
    }, 30000);

    return () => {
      clearTimeout(timer);
    };
  }, [dispatch, handleModalClose]);

  return (
    <div className="column flex-c">
      <Icon
        name="tick-circle"
        className="h3 success bold m-b-xs"
      />
      <div className={styles.approved}>Request Updated Successfully</div>
    </div>
  );
}

export default SuccessStage;
